import { Component } from "react";

import { withTranslation } from "react-i18next";
import type { WithTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { OpenAPI } from "simplydo/interfaces";

import util from "utils/utils";

import type { FeedCardSharedProps, FeedIdeaItem } from "../types";
import FeedCard from "./FeedCard";

type CardLeftProps = { idea: FeedIdeaItem };

const CardLeft = ({ idea }: CardLeftProps) => (
  <div style={{ maxHeight: "100%" }}>
    <div className="cover-and-text">
      <Link
        to={`/ideas/${idea._id}`}
        className="image-link"
        style={{
          display: "inline-block",
          width: 50,
          minWidth: 50,
          height: 50,
          borderRadius: 10,
          backgroundSize: "cover",
          backgroundPosition: "center center",
          backgroundImage: `url(${util.mixinCssUrlFallback(util.ideaCoverImage(idea, "200x200"), util.ideaCoverImage(undefined))})`,
        }}
      />
      <div className="content-name">
        <Link to={`/ideas/${idea._id}`}>{idea.name}</Link>
      </div>
    </div>
  </div>
);

type IdeaCardOwnProps = FeedCardSharedProps & {
  idea: FeedIdeaItem;
  profileFeed?: boolean;
  isGroupFeed?: boolean;
};

type IdeaCardProps = IdeaCardOwnProps &
  WithTranslation & { currentUser?: OpenAPI.Schemas["PreparedUser"] };

class IdeaCard extends Component<IdeaCardProps> {
  render() {
    const {
      idea,
      currentUser,
      profileFeed,
      hideAction,
      isGroupFeed,
      t,
      feedType,
    } = this.props;
    return (
      <FeedCard
        ownerType={idea.company ? "company" : "user"}
        company={idea.ownerCompany}
        user={idea.owner}
        feedType={feedType}
        action={
          profileFeed || isGroupFeed || idea.user === currentUser?._id
            ? "activityFeed.idea.created"
            : "activityFeed.idea.collaborate"
        }
        date={idea.createdAt}
        toLink={`/ideas/${idea._id}`}
        type={t("generic.idea")}
        cardContent={<CardLeft idea={idea} />}
        hideAction={hideAction}
      />
    );
  }
}

const mapStateToProps = (state: {
  user?: OpenAPI.Schemas["PreparedUser"];
}) => ({ currentUser: state.user });
const IdeaCardContainer = connect(mapStateToProps)(IdeaCard);

export default withTranslation()(IdeaCardContainer);
